import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

export const StyledTrafficChangeIndicator = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const StyledArrowIcon = styled(SWReactIcons)`
  width: 12px;
  height: 12px;
  & svg {
    width: 12px;
    height: 12px;
  }
`;

export const StyledChangeValue = styled.span<{ variant: 'green' | 'red' }>`
  color: ${({ variant }) => (variant === 'green' ? colorsPalettes.green.s100 : colorsPalettes.red.s100)};
  font-size: 12px;
  font-weight: 500;
  line-height: 10px;
  margin-right: 5px;
`;
